import React, { Component } from "react";
import { getUserId,aPIURL,getUser,websiteUrl } from '../../utils/common';

const HistoryonMap = (props) => 
{ 
     
       var WEB_URL=websiteUrl();//"https://login.avtbharat.com/";
       //var WEB_URL="http://localhost:3000/"; 
       
      const strUrl=WEB_URL+`MapHistorywithPoint.html?IMEI=${props.Historyobj.IMEI} &FromDate=${props.Historyobj.fromDate}&ToDate=${props.Historyobj.toDate}`;
//alert(strUrl);
     return ( 
      <>                  
       <iframe width="100%" height="600px" src={strUrl}  title="History on Map " ></iframe>  
       </>       
       )}; 
   
export default HistoryonMap;

